export default "/app/global-wrapper-client/static/437cd82407d698ae70251b24307d8011.woff2";